/**
 * FBSBancaSUMAK
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface PrestamoRubloModeloMLS { 
    fecha?: string;
    cuota?: number;
    secuencial?: number;
    capital?: number;
    interes?: number;
    otros?: number;
    total?: number;
}